import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewportSizeDirective } from './viewport-size.directive';

@NgModule({
  declarations: [ViewportSizeDirective],
  imports: [CommonModule],
  exports: [ViewportSizeDirective],
})
export class ViewportSizeModule {}
